import apis, { OrderItemUpdateKey } from '@/apis/purchase';
import { useState } from "react";

type EditByKey<T> = (key: OrderItemUpdateKey, value: T, successCallback: () => void) => Promise<void>;

type UseEditByKey = <T>(id: string) => [EditByKey<T>, boolean];

const useEditByKey: UseEditByKey = <T>(id: string) => {
  const [loading, setLoading] = useState<boolean>(false);

  const onEdit: EditByKey<T> = async (key, value, successCallback) => {
    if (id && key) {
      setLoading(true);
      try {
        await apis.itemUpdateByKey(id, { key, value });
        successCallback();
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
  };

  return [onEdit, loading];
};

export default useEditByKey;
